import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { withStateHandlers } from 'recompose';
import { Button, ButtonToolbar, Clearfix, Modal } from 'react-bootstrap';

export const confirmAttachmentsModalPropTypes = {
  openConfirmAttachmentsModal: PropTypes.func.isRequired,
  closeConfirmAttachmentsModal: PropTypes.func.isRequired,
  showConfirmAttachmentsModal: PropTypes.bool.isRequired,
};


export const withConfirmAttachmentsModalState = withStateHandlers(
  (props) => { return { showConfirmAttachmentsModal: false }; },
  {
    openConfirmAttachmentsModal: (state, props) => {
      return () => { return { showConfirmAttachmentsModal: true }; };
    },
    closeConfirmAttachmentsModal: (state, props) => {
      return () => { return { showConfirmAttachmentsModal: false }; };
    },
  },
);


const propTypes = exact({
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  confirmSubmit: PropTypes.func.isRequired,
});


const TicketAttachmentsConfirmModal = (props) => {
  const { show, onHide, confirmSubmit } = props;

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Deleting Attachement</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete this attachment?
        <Clearfix>
          <ButtonToolbar className="pull-right">
            <Button
              bsStyle="warning"
              onClick={onHide}
            >
              Close
            </Button>
            <Button
              bsStyle="danger"
              onClick={confirmSubmit}
            >
              Confirm
            </Button>
          </ButtonToolbar>
        </Clearfix>
      </Modal.Body>
    </Modal>
  );
};


TicketAttachmentsConfirmModal.propTypes = propTypes;


export default TicketAttachmentsConfirmModal;
